module.exports = __webpack_public_path__ + "static/media/exercises_chiffre_bg.7006d833.png";